var d = Object.defineProperty;
var h = (e, t, n) => t in e ? d(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n;
var r = (e, t, n) => (h(e, typeof t != "symbol" ? t + "" : t, n), n);
const a = {
  LOCAL: "local",
  STAGING: "staging",
  PROD: "prod"
}, i = {
  PROD: "https://accounts.credenza3.com",
  STAGING: "https://accounts.staging.credenza3.com",
  LOCAL: "http://localhost:8081"
};
function s(e) {
  switch (e.env) {
    case a.LOCAL:
      return i.LOCAL;
    case a.STAGING:
      return i.STAGING;
    case a.PROD:
      return i.PROD;
    default:
      throw new Error("Invalid sdk env");
  }
}
class w {
  constructor() {
    r(this, "name", "account");
    r(this, "sdk");
  }
  async _initialize(t) {
    this.sdk = t;
  }
  async _updateAccountContact(t) {
    const n = `${s(this.sdk)}/accounts/me/change-contact`, o = await fetch(n, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${this.sdk.getAccessToken()}`
      },
      body: JSON.stringify({
        ..."email" in t ? { email: t.email.trim() } : {},
        ..."phone" in t ? { phone: t.phone.trim() } : {},
        ..."code" in t ? { code: t.code.trim() } : {}
      })
    });
    if (!o.ok)
      throw new Error(`Request failed: ${o.statusText}`);
    return await o.json();
  }
  async changeEmail(t) {
    return await this._updateAccountContact({ email: t });
  }
  async changePhone(t) {
    return await this._updateAccountContact({ phone: t });
  }
  async verifyCode(t) {
    return await this._updateAccountContact({ code: t });
  }
  async pendingVerificationContacts() {
    const t = `${s(this.sdk)}/accounts/me/change-contact`, n = await fetch(t, {
      headers: {
        Authorization: `Bearer ${this.sdk.getAccessToken()}`
      }
    });
    if (!n.ok)
      throw new Error(`Request failed: ${n.statusText}`);
    return await n.json();
  }
  async info() {
    const t = `${s(this.sdk)}/oauth2/userinfo`, n = await fetch(t, {
      headers: {
        Authorization: `Bearer ${this.sdk.getAccessToken()}`
      }
    });
    if (!n.ok)
      throw new Error(`Cannot get userInfo: ${n.statusText}`);
    return await n.json();
  }
  async updateProfile(t) {
    if (!t.name && !t.picture)
      throw new Error("Nothing to update");
    const n = `${s(this.sdk)}/accounts/me`, o = await fetch(n, {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${this.sdk.getAccessToken()}`
      },
      body: JSON.stringify({
        ...t.name ? { name: t.name.trim() } : {},
        ...t.picture ? { image: t.picture.trim() } : {}
      })
    });
    if (!o.ok)
      throw new Error(`Cannot update user: ${o.statusText}`);
    return await o.json();
  }
  async changePassword(t) {
    if (!t.oldPassword || !t.newPassword)
      throw new Error("Invalid parameters");
    if (t.newPassword !== t.confirmPassword)
      throw new Error("Passwords do not match");
    const n = `${s(this.sdk)}/accounts/me/password`, o = await fetch(n, {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${this.sdk.getAccessToken()}`
      },
      body: JSON.stringify({
        old_password: t.oldPassword.trim(),
        new_password: t.newPassword.trim(),
        confirm_password: t.confirmPassword.trim()
      })
    });
    if (!o.ok)
      throw new Error(`Cannot change password: ${o.statusText}`);
    return await o.json();
  }
}
export {
  w as AccountExtension
};
